/* eslint-disable no-unused-vars */
import { ThemeProvider, createTheme } from "@mui/material"
import Header from "../Header/Header"
import Navbar from "../Navbar/Navbar"
import Footer from "../Footer/Footer"
import Request from "../Request/Request"
import { themeOptions } from "../../theme/theme"

const theme = createTheme(themeOptions)
function Layout({ children }) {
    return (
        <>
            <ThemeProvider theme={theme}>
                <Navbar></Navbar>
                {children}
                <Footer></Footer>
            </ThemeProvider>
        </>
    )
}

export default Layout